import api from "../../../helpers/axios";

class FacilityServiceV2 {
  async getFacilities() {
    const response = await api.get("/facility/");
    return response?.data || [];
  }

  async getFacilityById(facilityId) {
    const response = await api.get(`/facility/${facilityId}`);
    return response?.data;
  }

  async createFacility(facilityData) {
    const response = await api.post("/facility/", facilityData);
    return response.data;
  }

  async updateFacility(facilityId, facilityData) {
    const response = await api.patch(`/facility/${facilityId}`, facilityData);
    return response.data;
  }

  async getFacilityModelSettings() {
    const response = await api.get("/models/facility-settings");
    return response.data;
  }

  async updateFacilityModelSettings(facilityConfigId, settingsData) {
    const payload = {
      is_enabled_for_users: settingsData.is_enabled_for_users,
      is_default_for_facility: settingsData.is_default_for_facility,
      facility_temperature_override: settingsData.facility_temperature_override,
      facility_max_tokens_override: settingsData.facility_max_tokens_override,
    };
    const response = await api.put(`/models/facility-settings/${facilityConfigId}`, payload);
    return response.data;
  }
}

export default new FacilityServiceV2();
